import Authorization from "./authorization";

export default Authorization;
